<template>
  <app-content class="h-panel">
    <div class="h-panel-bar"><span class="h-panel-title">权限分配</span></div>
    <div class="margin-top margin-left">
      <Button color="primary" @click="showForm=true">新增</Button>
    </div>
    <div class="h-panel-body">
      <Table :datas="datas" :border="true" >
        <TableItem title="用户名" prop="realName" align="center"></TableItem>
        <TableItem title="手机号" prop="mobile" align="center"></TableItem>

        <TableItem title="账套权限" prop="roleType" align="center" dict="roles"></TableItem>
        <!--        <TableItem title="权限分配" align="center">
                  <div class="actions" slot-scope="{data}">
                    <template >
                      <span @click="details(data)">详情</span>
                    </template>
                  </div>
                </TableItem>-->
        <TableItem title="权限操作" align="center">
          <div class="actions" slot-scope="{data}">
            <template >
              <span @click="edit(data)" >修改权限</span>
              <span @click="remove(data)" >删除权限</span>
            </template>
          </div>

        </TableItem>
      </Table>

    </div>

    <Modal v-model="showForm" hasCloseIcon type="drawer-right">
      <div slot="header">权限配置</div>
      <Form ref="form" v-width="500" :labelWidth="80" :model="form" :rules="validationRules">
        <FormItem label="用户名" prop="userId" >
          <el-select v-model="form.userId" filterable :disabled="form.id">
            <el-option
                v-for="item in userList"
                :key="item.id"
                :label="item.realName"
                :value="item.id"
            />
          </el-select>
        </FormItem>
                <Radio class="cus-h-radio" v-model="form.roleType" :datas="roles">
                  <template slot="item" slot-scope="{item}">
                    <span>{{item.title}}</span>
                    <div class="desc">{{item.desc}}</div>
                  </template>
                </Radio>
      </Form>
      <div class="text-center margin-top">
        <Button color="green" @click="addUser" :loading="loading">{{!form.id?'确定':'更新'}}</Button>
        <Button @click="showForm=false">取消</Button>
      </div>
    </Modal>
    <Modal v-model="showNewForm" hasCloseIcon>
      <div class="h-panel-body" >

        <Table :datas="dataList" :border="true" >
          <TableItem title="关联账套" prop="companyName" align="center">
          </TableItem>
          <TableItem title="关联权限" prop="roleType" dict="roles" align="center">
          </TableItem>
        </Table>

      </div>
    </Modal>

  </app-content>
</template>

<script>

import {mapState} from 'vuex';
import SmsVerificationCode from "../../components/SmsVerificationCode";
import setting from "@/api/setting";

const emptyForm = {
  "id": null,
  "userId": "",
  "accountSetsId": "",
  "roleType": "Making",
};

export default {
  name: 'PermissionSetting',
  components: {SmsVerificationCode},
  data() {
    return {
      datas: [],
      dataList: [],
      userList: [],
      accountSetsId: null,
      accountSetsList: null,

      roles: [
        {
          key: 'Manager',
          title: '账套管理人',
          desc: '凭证 | 结账 | 账簿 | 报表 | 设置 '
        },
         {
          key: 'Making',
          title: '制单人',
          desc: '新增、查看凭证 | 结账 | 账簿 | 报表  '
        },
        {
          key: 'Audit',
          title: '审核人',
          desc: '审核、查看凭证 | 结账 | 账簿 | 报表  '
        },{
          key: 'View',
          title: '查看',
          desc: '查看凭证 | 账簿 | 报表 '
        }],
      form: Object.assign({}, emptyForm),
      showNewForm: false,
      showHandOver: false,
      showForm: false,
      loading: false,
      authenticated: false,
      receiverMobile: '',
      msgSended: false,
      msgTxt: '发送验证码',
      msgCode: '',
      verificationCode: '',
      validationRules: {
        required: ['userId',,'roleType'],
        userId: ['userId'],
        roleType: ['roleType']
      }
    };
  },
  computed: {
    ...mapState(['currentAccountSets', 'User', 'myAccountSets']),
  },
  watch: {
    showForm(val) {
      if (!val) {
        this.reset();
      }
    }
  },
  methods: {
    loadList() {
      setting.userAccountSets.list(this.accountSetsId).then(({data}) => {
        this.datas = data || [];
        setting.user.list().then((res)=>{
          this.userList = res.data
        })
      })
    },
    addUser(){
      this.form.accountSetsId = this.accountSetsId
      let validResult = this.$refs.form.valid();
      if(validResult.result){
        setting.userAccountSets[this.form.id ? 'update' : 'save'](this.form).then(()=>{
          this.loadList()
          this.showForm = false
        })
      }

    },
    addNewUser() {
      if (!this.msgCode) {
        this.$Message('请输入验证码！');
        return
      }

      this.loading = true;
      this.$api.setting.accountSets.addNewUser(Object.assign({}, this.form, {code: this.msgCode})).then(() => {
        this.loadList();
        this.showForm = false;
        this.showNewForm = false;
        this.loading = false;
      }).catch((rs) => {
        this.loading = false;
      });
    },

    edit(data) {


      this.form = {
        roleType: data.roleType,
        userId: data.userId,
        id: data.id
      };
      this.showForm=true
    },
    remove(data) {
      this.$Confirm("确认删除?").then(() => {
        setting.userAccountSets.delete(data.id).then(() => {
          this.loadList();
        })
      })
    },
    reset() {
      this.form = Object.assign({}, emptyForm);
    },
    handOver() {
      if (this.verificationCode) {
        if (!this.authenticated) {
          //移交人身份确认
          this.$api.setting.accountSets.identification({code: this.verificationCode}).then(() => {
            this.verificationCode = "";
            this.authenticated = true;
          });
        } else {
          //移交亲，请再次确定是否移交该账套，移交成功后，接收人登录柠檬云即可查看该账套：浙江欧易新能源有限公司
          this.$api.setting.accountSets.handOver({mobile: this.receiverMobile, code: this.verificationCode}).then(() => {
            window.location.replace("/");
          });
        }
      }
    }
  },
  mounted() {

    this.accountSetsList  = this.myAccountSets;
    this.accountSetsId = this.currentAccountSets.id;
    this.loadList();

  }
};
</script>
<style lang="less">
.cus-h-radio {
  > label {
    display: block;
    height: auto;

    .desc {
      color: @dark4-color;
      padding-left: 20px;
    }
  }
}
</style>
